var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ib-dialog",
    {
      attrs: { id: "comp-dialog", width: _vm.$media.l ? "75%" : "98%" },
      model: {
        value: _vm.show,
        callback: function ($$v) {
          _vm.show = $$v
        },
        expression: "show",
      },
    },
    [
      _c("template", { slot: "header" }, [
        _c("h2", { staticClass: "ib-col insetx-32 insety-16" }, [
          _vm._v(_vm._s(_vm.$t("company_search"))),
          _c(
            "span",
            { staticClass: "float-right fs4", on: { click: _vm.close } },
            [
              _c("svg", { attrs: { viewBox: "0 0 24 24" } }, [
                _c("path", {
                  attrs: { d: "M12 0a12 12 0 1012 12A12 12 0 0012 0z" },
                }),
                _c("path", {
                  attrs: {
                    d: "M13.414 12l3.293 3.293a1 1 0 11-1.414 1.414L12 13.414l-3.293 3.293a1 1 0 11-1.414-1.414L10.586 12 7.293 8.707a1 1 0 111.414-1.414L12 10.586l3.293-3.293a1 1 0 111.414 1.414z",
                    fill: "#fff",
                  },
                }),
              ]),
            ]
          ),
        ]),
      ]),
      _c("template", { slot: "default" }, [
        _c(
          "div",
          {
            staticClass:
              "offset-xl1 offset-l1 offset-m1 xl10 l10 m10 s11 small-table",
            class: { "outsety-24": !_vm.$media.s },
          },
          [
            _c("p", [
              _vm._v(
                _vm._s(_vm.$t("use_search_form")) +
                  "  " +
                  _vm._s(_vm.$t("then_check_add"))
              ),
              _c("b", [_vm._v(" " + _vm._s(_vm.$t("add_max_companies")))]),
            ]),
            _c(
              "ib-form",
              { staticClass: "ticker flex-flex outsety-16" },
              [
                _c("ib-field", {
                  staticClass: "ticker-field mb50",
                  attrs: {
                    placeholder: _vm.$t("ticker_company"),
                    uppercase: "",
                    width: "100%",
                    autofocus: "",
                  },
                  model: {
                    value: _vm.curSearch,
                    callback: function ($$v) {
                      _vm.curSearch = $$v
                    },
                    expression: "curSearch",
                  },
                }),
                _c(
                  "span",
                  {
                    staticClass: "bg15-inverse cancel",
                    on: { click: _vm.clearTicker },
                  },
                  [
                    _c("svg", { attrs: { viewBox: "0 0 20 20" } }, [
                      _c("path", {
                        attrs: {
                          d: "M10 0a10 10 0 1010 10A10.029 10.029 0 0010 0z",
                        },
                      }),
                      _c("path", {
                        attrs: {
                          d: "M14.9 13.5l-1.4 1.4-3.5-3.5-3.5 3.5-1.4-1.4L8.6 10 5.1 6.5l1.4-1.4L10 8.6l3.5-3.5 1.4 1.4-3.5 3.5z",
                          fill: "#fff",
                        },
                      }),
                    ]),
                  ]
                ),
                _c(
                  "button",
                  {
                    staticClass: "magnify",
                    on: {
                      click: function ($event) {
                        return _vm.getComp(false)
                      },
                    },
                  },
                  [
                    _c("svg", { attrs: { viewBox: "0 0 50 50" } }, [
                      _c("path", {
                        attrs: {
                          d: "M21 3C11.6 3 4 10.6 4 20a16.99 16.99 0 0 0 26.1 14.34l12.27 12.28 4.26-4.24-12.13-12.1A16.99 16.99 0 0 0 21 3zm0 4c7.2 0 13 5.8 13 13s-5.8 13-13 13S8 27.2 8 20 13.8 7 21 7z",
                        },
                      }),
                    ]),
                  ]
                ),
              ],
              1
            ),
            _vm.total > 0 || _vm.total === -1
              ? _c(
                  "div",
                  { staticClass: "insety-4" },
                  [
                    _c("h3", [
                      _vm._v(
                        _vm._s(_vm.$t("company_results")) +
                          ': "' +
                          _vm._s(_vm.previousSearch) +
                          '"'
                      ),
                    ]),
                    _c("div", { staticClass: "border-bottom bg-gray100" }),
                    _vm.total === -1
                      ? _c(
                          "ib-infobox",
                          {
                            staticClass: "outsety-16",
                            attrs: { tone: "error" },
                          },
                          [_vm._v("No companies found.")]
                        )
                      : _vm._e(),
                    _vm.searchResults.length > 0
                      ? _c(
                          "ib-table-basic",
                          {
                            staticClass: "outsety-16 border",
                            attrs: {
                              spacing: "compact",
                              data: _vm.searchResults,
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "body",
                                  fn: function (comp) {
                                    return [
                                      _c(
                                        "td",
                                        { staticClass: "ticker-remove" },
                                        [
                                          comp._added
                                            ? _c(
                                                "span",
                                                {
                                                  staticClass: "fg-add",
                                                  class: {
                                                    "insetx-8": _vm.$media.l,
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "svg",
                                                    {
                                                      attrs: {
                                                        viewBox: "0 0 24 24",
                                                      },
                                                    },
                                                    [
                                                      _c("path", {
                                                        attrs: {
                                                          d: "M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10c5.2 0 9.4-3.9 9.9-9h-2c-.5 3.9-3.9 7-7.9 7-4.4 0-8-3.6-8-8a8.03 8.03 0 0 1 11.9-7l1.5-1.5C15.8 2.6 14 2 12 2zm8.5 2.88l-9.31 8.9L7.5 10.1 6.1 11.5l5.09 5.1.72-.7 10-9.59z",
                                                        },
                                                      }),
                                                    ]
                                                  ),
                                                ]
                                              )
                                            : _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "fg-add hover-black",
                                                  class: {
                                                    "insetx-8": _vm.$media.l,
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.addTicker(comp)
                                                    },
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "svg",
                                                    {
                                                      attrs: {
                                                        viewBox: "0 0 24 24",
                                                      },
                                                    },
                                                    [
                                                      _c("path", {
                                                        attrs: {
                                                          d: "M12 0a12 12 0 1012 12A12 12 0 0012 0z",
                                                        },
                                                      }),
                                                      _c("path", {
                                                        attrs: {
                                                          d: "M18 13h-5v5a1 1 0 01-2 0v-5H6a1 1 0 010-2h5V6a1 1 0 012 0v5h5a1 1 0 010 2z",
                                                          fill: "#fff",
                                                        },
                                                      }),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                        ]
                                      ),
                                      _vm.$media.l
                                        ? _c("td", [
                                            _c("span", [
                                              _vm._v(_vm._s(comp.ticker)),
                                            ]),
                                          ])
                                        : _vm._e(),
                                      _c("td", {
                                        class: { fs8: !_vm.$media.l },
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.formatComp(comp.name)
                                          ),
                                        },
                                      }),
                                      comp.type === "stocks"
                                        ? _c("td", [
                                            _c("span", [
                                              _vm._v(_vm._s(_vm.$t("stock"))),
                                            ]),
                                          ])
                                        : comp.type === "etfs"
                                        ? _c("td", [
                                            _c("span", [
                                              _vm._v(_vm._s(_vm.$t("etf"))),
                                            ]),
                                          ])
                                        : _vm._e(),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              3472227767
                            ),
                          },
                          [
                            !_vm.$media.l
                              ? _c("ib-table-col", { attrs: { width: "4ch" } })
                              : _c("ib-table-col", { attrs: { width: "6ch" } }),
                            _vm.$media.l
                              ? _c(
                                  "ib-table-col",
                                  { attrs: { width: "12ch" } },
                                  [_vm._v(_vm._s(_vm.$t("symbol")))]
                                )
                              : _vm._e(),
                            _c("ib-table-col", [
                              _vm._v(_vm._s(_vm.$t("name"))),
                            ]),
                            _c("ib-table-col", [
                              _vm._v(_vm._s(_vm.$t("type"))),
                            ]),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.searchResults.length > 0
                      ? _c(
                          "div",
                          { staticClass: "fixed-fixed after-16" },
                          [
                            _c("ib-dropdown", {
                              class: { fullWidth: !_vm.$media.l },
                              attrs: {
                                data: _vm.dropdownData,
                                placeholder: _vm.$t("show_rows"),
                                align: "center",
                              },
                              on: { change: _vm.changeShown },
                              model: {
                                value: _vm.numShow,
                                callback: function ($$v) {
                                  _vm.numShow = $$v
                                },
                                expression: "numShow",
                              },
                            }),
                            _c(
                              "div",
                              {
                                staticClass: "flex-fixed",
                                class: { "pagination-small": !_vm.$media.l },
                              },
                              [
                                _c("span", [_vm._v(_vm._s(_vm.$t("page")))]),
                                _c("ib-field", {
                                  staticClass: "outsetx-8",
                                  attrs: {
                                    disabled: _vm.totalPages <= 1,
                                    width: "5ch",
                                    align: "center",
                                    placeholder: "1",
                                  },
                                  on: { change: _vm.changePage },
                                  model: {
                                    value: _vm.page,
                                    callback: function ($$v) {
                                      _vm.page = $$v
                                    },
                                    expression: "page",
                                  },
                                }),
                                _c("span", [
                                  _vm._v(_vm._s(_vm.$t("of"))),
                                  _c(
                                    "strong",
                                    { staticStyle: { "margin-left": "4px" } },
                                    [_vm._v(_vm._s(_vm.totalPages))]
                                  ),
                                ]),
                                _c(
                                  "div",
                                  {
                                    staticClass: "outsetx-16",
                                    staticStyle: { "align-self": "center" },
                                  },
                                  [
                                    _c(
                                      "ib-button",
                                      {
                                        staticClass: "page-btn",
                                        attrs: { disabled: _vm.page <= 1 },
                                        on: {
                                          click: function ($event) {
                                            return _vm.changePage(--_vm.page)
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "svg",
                                          { attrs: { viewBox: "0 0 24 24" } },
                                          [
                                            _c("path", {
                                              attrs: {
                                                d: "M14.78 2.28l-9 9-.69.72.7.72 9 9 1.43-1.44L7.94 12l8.28-8.28z",
                                              },
                                            }),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "ib-button",
                                      {
                                        staticClass: "page-btn",
                                        attrs: {
                                          disabled: _vm.page >= _vm.totalPages,
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.changePage(++_vm.page)
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "svg",
                                          { attrs: { viewBox: "0 0 24 24" } },
                                          [
                                            _c("path", {
                                              attrs: {
                                                d: "M8.7 2.3L7.3 3.7l8.29 8.3-8.3 8.3 1.42 1.4 9.7-9.7z",
                                              },
                                            }),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ],
                  1
                )
              : _vm._e(),
            _vm.selectedCompanies.length > 0
              ? _c(
                  "div",
                  { staticClass: "border-top" },
                  [
                    _c("h3", { staticClass: "before-16" }, [
                      _vm._v(_vm._s(_vm.$t("selected_companies"))),
                    ]),
                    _c("div", { staticClass: "border-bottom bg-gray100" }),
                    _c(
                      "ib-table-basic",
                      {
                        staticClass: "outsety-16 border",
                        attrs: {
                          spacing: "compact",
                          data: _vm.selectedCompanies,
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "body",
                              fn: function (comp) {
                                return [
                                  _c("td", { staticClass: "ticker-remove" }, [
                                    _c(
                                      "span",
                                      {
                                        staticClass: "fg-remove hover-black",
                                        class: { "insetx-8": _vm.$media.l },
                                        on: {
                                          click: function ($event) {
                                            return _vm.removeTicker(comp)
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "svg",
                                          { attrs: { viewBox: "0 0 20 20" } },
                                          [
                                            _c("path", {
                                              attrs: {
                                                d: "M10 0a10 10 0 1010 10A10.029 10.029 0 0010 0z",
                                              },
                                            }),
                                            _c("path", {
                                              attrs: {
                                                d: "M14.9 13.5l-1.4 1.4-3.5-3.5-3.5 3.5-1.4-1.4L8.6 10 5.1 6.5l1.4-1.4L10 8.6l3.5-3.5 1.4 1.4-3.5 3.5z",
                                                fill: "#fff",
                                              },
                                            }),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _vm.$media.l
                                    ? _c("td", [
                                        _c("span", [
                                          _vm._v(_vm._s(comp.ticker)),
                                        ]),
                                      ])
                                    : _vm._e(),
                                  _c("td", {
                                    class: { fs8: !_vm.$media.l },
                                    domProps: {
                                      textContent: _vm._s(
                                        _vm.formatComp(comp.name)
                                      ),
                                    },
                                  }),
                                  comp.type === "stocks"
                                    ? _c("td", [
                                        _c("span", [
                                          _vm._v(_vm._s(_vm.$t("stock"))),
                                        ]),
                                      ])
                                    : comp.type === "etfs"
                                    ? _c("td", [
                                        _c("span", [
                                          _vm._v(_vm._s(_vm.$t("etf"))),
                                        ]),
                                      ])
                                    : _vm._e(),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          916155281
                        ),
                      },
                      [
                        !_vm.$media.l
                          ? _c("ib-table-col", { attrs: { width: "4ch" } })
                          : _c("ib-table-col", { attrs: { width: "6ch" } }),
                        _vm.$media.l
                          ? _c("ib-table-col", { attrs: { width: "12ch" } }, [
                              _vm._v(_vm._s(_vm.$t("symbol"))),
                            ])
                          : _vm._e(),
                        _c("ib-table-col", [_vm._v(_vm._s(_vm.$t("name")))]),
                        _c("ib-table-col", [_vm._v(_vm._s(_vm.$t("type")))]),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ],
          1
        ),
      ]),
      _c("template", { slot: "footer" }, [
        _c(
          "div",
          { staticClass: "fullWidth fixed-fixed" },
          [
            _c(
              "ib-button",
              {
                staticClass: "cancelled outsety-8 text-center",
                class: {
                  fullWidth: !_vm.$media.xl,
                  "outsety-8": !_vm.$media.xl,
                },
                attrs: { disabled: _vm.selectedCompanies.length === 0 },
                on: { click: _vm.cancelData },
              },
              [_vm._v(_vm._s(_vm.$t("reset")))]
            ),
            _c(
              "ib-button",
              {
                staticClass: "added outsety-8 text-center",
                class: {
                  fullWidth: !_vm.$media.xl,
                  "outsety-8": !_vm.$media.xl,
                },
                attrs: {
                  disabled: _vm.selectedCompanies.length === 0,
                  tone: "accent",
                },
                on: { click: _vm.addData },
              },
              [_vm._v(_vm._s(_vm.$t("apply")))]
            ),
          ],
          1
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }